(function () {
  'use strict';

  var LOOK_PREFIX = '/pages/jewellery-look/';
  var SESSION_KEY = 'gaLookAttributionV1';
  var COOKIE_NAME = 'ga_last_look';
  var COOKIE_TTL_SECONDS = 1800;

  function safeParse(value) {
    try {
      return JSON.parse(value || '{}');
    } catch (error) {
      return {};
    }
  }

  function getLookHandle(pathname) {
    if (!pathname || pathname.indexOf(LOOK_PREFIX) !== 0) return '';
    return decodeURIComponent(pathname.slice(LOOK_PREFIX.length).replace(/\/$/, ''));
  }

  function normaliseTitle(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*[|–—-]\s*Galleria Armadoro.*$/i, '')
      .trim();
  }

  function getLookName(handle) {
    var heading = document.querySelector('[data-ga-look-title], .ga-look-detail h1, main h1');
    var title = heading ? heading.textContent : document.title;
    title = normaliseTitle(title);
    if (title) return title;
    return handle
      .split('-')
      .filter(Boolean)
      .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
      .join(' ');
  }

  function updateSessionState(handle, name, path) {
    var now = new Date().toISOString();
    var current = safeParse(sessionStorage.getItem(SESSION_KEY));
    var history = Array.isArray(current.history) ? current.history.slice() : [];

    history = history.filter(function (entry) {
      return entry && entry.handle !== handle;
    });
    history.push({ handle: handle, name: name, path: path, seenAt: now });
    history = history.slice(-5);

    var state = {
      firstSeenAt: current.firstSeenAt || now,
      lastSeenAt: now,
      firstLookHandle: current.firstLookHandle || handle,
      firstLookName: current.firstLookName || name,
      lastLookHandle: handle,
      lastLookName: name,
      history: history
    };

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    return state;
  }

  function writeCookie(handle) {
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(handle) +
      '; Path=/; Max-Age=' + COOKIE_TTL_SECONDS + '; SameSite=Lax';
  }

  function cartAttributesFromState(state) {
    return {
      '__ga_look_attribution': '1',
      '__ga_look_first': state.firstLookName,
      '__ga_look_first_handle': state.firstLookHandle,
      '__ga_look_last': state.lastLookName,
      '__ga_look_last_handle': state.lastLookHandle,
      '__ga_look_history': state.history.map(function (entry) { return entry.handle; }).join(' > '),
      '__ga_look_first_seen': state.firstSeenAt,
      '__ga_look_last_seen': state.lastSeenAt
    };
  }

  function persistToCart(state) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: cartAttributesFromState(state) })
    }).catch(function () {});
  }

  function publishAnalytics(name, handle, state) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga_look_view',
      ga_look_name: name,
      ga_look_handle: handle,
      ga_look_first: state.firstLookName,
      ga_look_last: state.lastLookName,
      ga_look_history: state.history.map(function (entry) { return entry.handle; }).join('|')
    });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'ga_look_view', {
        look_name: name,
        look_handle: handle,
        look_first: state.firstLookName,
        look_last: state.lastLookName
      });
    }
  }

  function init() {
    var path = window.location.pathname || '';
    var handle = getLookHandle(path);
    if (!handle) return;

    var name = getLookName(handle);
    var state = updateSessionState(handle, name, path);

    writeCookie(handle);
    persistToCart(state);
    publishAnalytics(name, handle, state);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();